module.exports = __webpack_public_path__ + "static/img/Schneider_Sustainability_green.d6b3da2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/Schneider_Sustainability_green.png
// module id = m1o+
// module chunks = 0